import React from "react";

import {
  HomeCollaborations,
  HomeHero,
  HomeOverview,
  HomeRoles,
} from "../../components/home";

const HomeView = () => (
  <div>
    <HomeHero />
    <HomeOverview />
    <HomeCollaborations />
    <HomeRoles />
  </div>
);

export default HomeView;
